// import React from "react";
// import "./ObjectCard.css";

// export default function ObjectCard({ object, onClose }) {
//   const commonFields = [
//     { label: "Name", value: object.common_fields.name },
//     { label: "Confidence", value: `${(object.common_fields.confidence * 100).toFixed(1)}%` }
//   ];

//   return (
//     <div className="absolute inset-0 bg-white/30 backdrop-blur-lg flex items-center justify-center">
//       <div className="object-card">
//         <div className="object-card-header">
//           <h3>Object Details</h3>
//           <button onClick={onClose} className="close-button">
//             ×
//           </button>
//         </div>

//       <div className="object-card-content">
//         <div className="common-fields">
//           <h4>Object Information</h4>
//           {commonFields.map((field, index) => (
//             <div key={index} className="field">
//               <span className="label">{field.label}:</span>
//               <span className="value">{field.value}</span>
//             </div>
//           ))}
//         </div>

//         {/* Detection-specific fields */}
//         {/* {object.detection_specific && Object.keys(object.detection_specific).length > 0 && (
//           <div className="detection-specific">
//             <h4>Detection Details</h4>
//             {Object.entries(object.detection_specific).map(([key, value], index) => (
//               <div key={index} className="field">
//                 <span className="label">{key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}:</span>
//                 <span className="value">
//                   {typeof value === 'number' ? value.toFixed(3) : String(value)}
//                 </span>
//               </div>
//             ))}
//           </div>
//         )} */}
//       </div>
//     </div>
//     </div>
//   );
// } 
import React from "react";
import "./ObjectCard.css";

export default function ObjectCard({ object, onClose }) {
  const name = object.common_fields?.name || "Object";
  const confidencePct = typeof object.common_fields?.confidence === "number"
    ? `${(object.common_fields.confidence * 100).toFixed(1)}%`
    : "—";
  const previewImageUrl = object.common_fields?.preview_image_url || null;

  // Build detection-specific fields, skipping noisy or duplicate keys
  const detectionEntries = Object.entries(object.detection_specific || {}).filter(
    ([key]) => !["bbox"].includes(key)
  );

  return (
    <div className="absolute inset-0 bg-white/30 backdrop-blur-lg flex items-center justify-center">
      <div className="object-card">
        <div className="object-card-header">
          <h3>{name}</h3>
          <button onClick={onClose} className="close-button">×</button>
        </div>

        <div className="object-card-content">
          {previewImageUrl && (
            <div className="object-hero">
              <img
                className="object-image"
                src={previewImageUrl}
                alt={name}
                loading="lazy"
              />
              <div className="object-hero-meta">
                <div className="confidence-badge">Confidence: {confidencePct}</div>
              </div>
            </div>
          )}

          {!previewImageUrl && (
            <div className="common-fields">
              <h4>Object Information</h4>
              <div className="field">
                <span className="label">Name:</span>
                <span className="value">{name}</span>
              </div>
              <div className="field">
                <span className="label">Confidence:</span>
                <span className="value">{confidencePct}</span>
              </div>
            </div>
          )}

          {detectionEntries.length > 0 && (
            <div className="detection-specific">
              <h4>Details</h4>
              {detectionEntries.map(([key, value], index) => (
                <div key={index} className="field">
                  <span className="label">
                    {key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}:
                  </span>
                  <span className="value">
                    {typeof value === "number" ? value.toFixed(3) : String(value)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}